import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const helpers = createMultiStyleConfigHelpers([
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
]);

const ComparisonTable = helpers.defineMultiStyleConfig({
  baseStyle: {
    table: {
      width: '100%',
      tableLayout: 'fixed',
    },
    th: {
      textAlign: 'center',
      textTransform: 'capitalize',
      border: 'none',
      bg: 'white',
    },
    td: {
      textAlign: 'center',
      border: 'none',
    },
    tr: {},
    thead: {},
    tbody: {},
  },
  variants: {
    comparison: {
      table: {
        // Column headers: 56px top, 16px bottom, 16px/72px horizontal
        '&&& thead tr th': {
          paddingTop: '56px !important',
          paddingBottom: '16px',
          paddingLeft: { base: '16px', md: '72px' },
          paddingRight: { base: '16px', md: '72px' },
        },
        // Section headers and data cells: 12px vertical, 16px/72px horizontal
        '&&& tbody tr td': {
          paddingTop: '12px',
          paddingBottom: '12px',
          paddingLeft: { base: '16px', md: '72px' },
          paddingRight: { base: '16px', md: '72px' },
        },
      },
    },
  },
  defaultProps: {
    variant: 'comparison',
  },
});

export default ComparisonTable;
